import { TableBody, TableBorderless, TableCell, TableHead, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

import { FieldData } from './field-carbon-table.component';

type FieldBasicInfoTableProps = {
  data: FieldData;
  className?: string;
};

export const FieldBasicInfoTable1 = ({ data, className }: FieldBasicInfoTableProps) => (
  <TableBorderless className={className}>
    <TableBody>
      <TableRow>
        <TableHead className="w-1/2">Field Number</TableHead>
        <TableCell className="text-right">{data.fieldInfo.generalInfo.fieldNumber}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Field Name</TableHead>
        <TableCell className="text-right">{data.fieldInfo.generalInfo.fieldName}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Field ID</TableHead>
        <TableCell className="text-right">{data.fieldInfo.generalInfo.fieldId}</TableCell>
      </TableRow>
    </TableBody>
  </TableBorderless>
);

export const FieldBasicInfoTable2 = ({ data }: FieldBasicInfoTableProps) => (
  <TableBorderless className={cn('border-t-2 border-secondary')}>
    <TableBody>
      <TableRow>
        <TableHead className="w-1/2">Field Land Use</TableHead>
        <TableCell className="text-right">{data.fieldInfo.terrainInfo.landUse}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Soil Type</TableHead>
        <TableCell className="text-right">{data.fieldInfo.generalInfo.fieldDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Terrain Type</TableHead>
        <TableCell className="text-right">{data.fieldInfo.terrainInfo.terrainType}</TableCell>
      </TableRow>
    </TableBody>
  </TableBorderless>
);

export const FieldBasicInfoTable3 = ({ data }: FieldBasicInfoTableProps) => (
  <TableBorderless className={cn('border-t-2 border-secondary')}>
    <TableBody>
      <TableRow>
        <TableHead className="w-1/2">Measured Field Area (ha)</TableHead>
        <TableCell className="text-right">{data.fieldInfo.terrainInfo.measuredFieldAreaHa}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Field Core Count</TableHead>
        <TableCell className="text-right">{data.carbonInfo.coreCount}</TableCell>
      </TableRow>
    </TableBody>
  </TableBorderless>
);

export const FieldBasicInfoTablesWeb = ({ data }: { data: FieldData }) => (
  <>
    <FieldBasicInfoTable1 data={data} />
    <FieldBasicInfoTable2 data={data} />
    <FieldBasicInfoTable3 data={data} />
  </>
);
